<template>
  <div class="options bg-light">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h2>What would you like to do next?</h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col option">
          <InertiaLink
            :href="route('asset.create', 'master-service-agreement')"
            class="card text-center bg-white"
          >
            <div class="card-body">
              <Icon
                icon="msa"
                :width="50"
                colour="#6666ff"
                class="mr-1"
              />
              <p>Create a new Master Service Agreement</p>
            </div>
          </InertiaLink>
        </div>
        <div class="col option">
          <InertiaLink
            :href="route('asset.create', 'work-category')"
            class="card text-center bg-white"
          >
            <div class="card-body">
              <Icon
                icon="workcategory"
                :width="50"
                colour="#6666ff"
                class="mr-1"
              />
              <p>Configure a Work Category</p>
            </div>
          </InertiaLink>
        </div>
        <div class="col option">
          <InertiaLink
            :href="route('asset.create', 'statement-of-work')"
            class="card text-center bg-white"
          >
            <div class="card-body">
              <Icon
                icon="sow"
                :width="50"
                colour="#6666ff"
                class="mr-1"
              />
              <p>Create a new Statement of Work</p>
            </div>
          </InertiaLink>
        </div>
        <div class="col option">
          <InertiaLink
            :href="route('asset.create', 'change-request')"
            class="card text-center bg-white"
          >
            <div class="card-body">
              <Icon
                icon="changerequest"
                :width="50"
                colour="#6666ff"
                class="mr-1"
              />
              <p>Create a Change Request</p>
            </div>
          </InertiaLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Icons/Icon';

export default {
  components: {
    Icon,
  },
};
</script>
